import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {showContextMenu} from '../../../core-components/context-menu/redux';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {reactReduxModal as chatChannelModal} from '../../../comments/redux/chatChannelModal';
import {reduxList, componentOptions} from '../../../comments/redux/userSubscriptions';
import {UserViewChannelsView} from './UserViewChannelsView';


/** @type {ReactReduxModalActions} */
const chatChannelModalActions = chatChannelModal.actions;

/** @type {ReduxObservableListActions} */
const userSubscriptionsActions = reduxList.actions;

const StreamedComponent = (state$, dispatch) => (props$) => {
  const onShowChat = (e, channel) => dispatch(chatChannelModalActions.showModal({
    parentId: channel.id,
    channel,
    allowNav: true,
  }));
  const onRemoveConversation = channelId => dispatch(userSubscriptionsActions.deleteItem({id: channelId}));
  const onAccessError = chatId => dispatch(userSubscriptionsActions.loadSuccess({[chatId]: null}));
  const onItemContextMenu = (event, channel) => {
    if (!channel) return;

    const actions = [];
    event.preventDefault();
    event.stopPropagation();
    event.persist();

    actions.push({
      messageId: 'user.conversations.remove.label',
      action: () => onRemoveConversation(getId(channel)),
    });

    dispatch(showContextMenu({
      event,
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: channel.name},
      cancelMessageId: 'defaults.context.cancel.label',
      actions,
    }));
  };

  return props$
    .map(props => ({
      ...props,
      onShowChat,
      onRemoveConversation,
      onAccessError,
      onItemContextMenu,
    }));
};

const ListComponent = ReduxListStreamedContainer(UserViewChannelsView, reduxList, componentOptions);
export const UserViewChannelsContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/user/components/UserViewChannels/UserViewChannelsContainer.js